var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaverick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    height: 120,
    width: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90h90V0H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 120)",
    fill: "#e8b000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.962 59.606c0-6.084-4.933-11.016-11.017-11.016s-11.016 4.932-11.016 11.016 4.932 11.017 11.016 11.017 11.017-4.933 11.017-11.017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.034 63.911a16.62 16.62 0 0 0 .583-4.305c0-7.788-5.375-14.327-12.605-16.149l-4.07-10.695L40.79 43.48c-7.185 1.854-12.517 8.371-12.517 16.127 0 1.49.215 2.925.582 4.3-16.453.45-22.58 6.548-22.58 6.548l38.611-60.98 38.703 60.98s-6.209-6.089-22.555-6.543"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaverick);
export default __webpack_public_path__ + "static/media/maverick.f84cd1fbb8d286c73499f4fbceeda833.svg";
export { ForwardRef as ReactComponent };